/* eslint-disable import/prefer-default-export */
export const BrandedAppNumber = {
  CIRCULAR_MATERIALS: 6,
};
